/* Little Luxe theme — vanilla JS, no dependencies */
(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* Toast */
  function toast(html) {
    const el = $('#ll-toast'); if (!el) return;
    el.innerHTML = html; el.classList.add('is-on');
    clearTimeout(toast.t); toast.t = setTimeout(() => el.classList.remove('is-on'), 2600);
  }

  /* Cart helpers */
  async function addItems(items) {
    const res = await fetch(root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items })
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || 'Could not add to basket');
    const cart = await (await fetch(root + 'cart.js')).json();
    $$('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; el.hidden = !cart.item_count; });
    return data;
  }
  function busy(btn, on) { if (!btn) return; btn.disabled = on; btn.style.opacity = on ? .6 : 1; }

  /* Quick add (product cards) */
  document.addEventListener('click', async e => {
    const q = e.target.closest('[data-quick-add]');
    if (!q) return;
    e.preventDefault(); busy(q, true);
    try { await addItems([{ id: +q.dataset.quickAdd, quantity: 1 }]); toast('Added to your basket · <a href="' + root + 'cart" style="text-decoration:underline">View basket</a>'); }
    catch (err) { toast(err.message); }
    busy(q, false);
  });

  /* Product form */
  $$('[data-product-form]').forEach(form => {
    const variants = JSON.parse(($('[data-variants]', form.closest('[data-product]')) || {}).textContent || '[]');
    const idInput = $('input[name="id"]', form);
    const submit = $('[data-add-btn]', form);
    const priceEl = $('[data-price]');
    const compareEl = $('[data-compare]');
    const klarnaEl = $('[data-klarna]');
    const money = c => '£' + (c % 100 === 0 ? c / 100 : (c / 100).toFixed(2));

    function selected() { return $$('[data-option-index]', form).map(g => { const c = $('input:checked', g); return c ? c.value : null; }); }
    function update() {
      const opts = selected();
      const v = variants.find(v => v.options.every((o, i) => o === opts[i]));
      $$('[data-option-index]', form).forEach((g, i) => { const l = $('[data-option-value]', g); if (l) l.textContent = opts[i]; });
      if (!v) { submit.disabled = true; submit.querySelector('span').textContent = 'Unavailable'; return; }
      idInput.value = v.id;
      submit.disabled = !v.available;
      submit.querySelector('span').textContent = v.available ? 'Add to basket — ' + money(v.price) : 'Sold out';
      if (priceEl) priceEl.textContent = money(v.price);
      if (compareEl) { compareEl.hidden = !(v.compare_at_price > v.price); compareEl.textContent = money(v.compare_at_price || 0); }
      if (klarnaEl) klarnaEl.textContent = money(Math.round(v.price / 3));
      if (v.featured_media) { const t = $('[data-thumb="' + v.featured_media.id + '"]'); t && t.click(); }
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
    }
    form.addEventListener('change', e => { if (e.target.closest('[data-option-index]')) update(); });

    form.addEventListener('submit', async e => {
      e.preventDefault(); busy(submit, true);
      const qty = Math.max(1, +($('[name="quantity"]', form) || {}).value || 1);
      const items = [{ id: +idInput.value, quantity: qty }];
      const up = $('[data-upsell]:checked');
      if (up) items.push({ id: +up.value, quantity: 1 });
      try { await addItems(items); toast((up ? 'Added — with the brush, nice choice' : 'Added to your basket') + ' · <a href="' + root + 'cart" style="text-decoration:underline">View basket</a>'); }
      catch (err) { toast(err.message); }
      busy(submit, false);
    });
  });

  /* Quantity steppers */
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-qty-step]'); if (!b) return;
    const input = b.parentElement.querySelector('input'); const min = +(input.min || 0);
    input.value = Math.max(min, (+input.value || 0) + (+b.dataset.qtyStep));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Cart page: auto-submit on qty change */
  $$('[data-cart-form] input[name="updates[]"]').forEach(i => i.addEventListener('change', () => {
    clearTimeout(i._t); i._t = setTimeout(() => i.form.submit(), 500);
  }));

  /* Gallery */
  document.addEventListener('click', e => {
    const t = e.target.closest('[data-thumb]'); if (!t) return;
    const wrap = t.closest('[data-gallery]');
    $$('[data-thumb]', wrap).forEach(b => b.classList.toggle('is-active', b === t));
    $$('[data-slide]', wrap).forEach(s => s.hidden = s.dataset.slide !== t.dataset.thumb);
  });

  /* Collection sort */
  $$('[data-sort]').forEach(s => s.addEventListener('change', () => {
    const u = new URL(location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); location.href = u;
  }));

  /* Drawer */
  document.addEventListener('click', e => {
    if (e.target.closest('[data-burger]')) $('#ll-drawer').classList.add('is-open');
    if (e.target.closest('[data-drawer-close]')) $('#ll-drawer').classList.remove('is-open');
  });

  /* Newsletter popup */
  const pop = $('#ll-popup');
  if (pop && !localStorage.getItem('ll-pop-seen') && !(window.Shopify && Shopify.designMode && !pop.dataset.preview)) {
    setTimeout(() => pop.classList.add('is-open'), (+pop.dataset.delay || 6) * 1000);
  }
  if (pop && window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:select', e => { if (e.target.querySelector('#ll-popup')) pop.classList.add('is-open'); });
    document.addEventListener('shopify:section:deselect', e => { if (e.target.querySelector('#ll-popup')) pop.classList.remove('is-open'); });
  }
  document.addEventListener('click', e => {
    if (e.target.closest('[data-pop-close]')) { pop.classList.remove('is-open'); localStorage.setItem('ll-pop-seen', '1'); }
  });
  if (location.search.includes('customer_posted=true')) localStorage.setItem('ll-pop-seen', '1');

  /* Reveal on scroll */
  const io = 'IntersectionObserver' in window ? new IntersectionObserver(es => es.forEach(en => {
    if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
  }), { threshold: .1 }) : null;
  $$('.ll-reveal').forEach(el => (io && el.getBoundingClientRect().top >= innerHeight) ? io.observe(el) : el.classList.add('is-in'));
  setTimeout(() => $$('.ll-reveal').forEach(el => el.classList.add('is-in')), 1500);
  document.addEventListener('shopify:section:load', () => $$('.ll-reveal').forEach(el => el.classList.add('is-in')));
})();
